import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import Select from 'react-select';
import { SERVER_BASE } from '../config/server';
import { useTable, useSortBy, usePagination, useGlobalFilter } from 'react-table';
import * as XLSX from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import DateRangePickerComponent from './CustomDateRangePicker';
import moment from 'moment';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const statusOptions = [
  { value: 'As Stock', label: 'As Stock' },
  { value: 'Installed/Fitted with Structure', label: 'Installed/Fitted with Structure' },
  { value: 'Installed/Fitted with Machinery', label: 'Installed/Fitted with Machinery' },
  { value: 'Installed/Fitted with Construction', label: 'Installed/Fitted with Construction' },
  { value: 'Installed/Fitted underground', label: 'Installed/Fitted underground' },
  { value: 'Installed/Fitted above roof', label: 'Installed/Fitted above roof' },
  { value: 'Installed/Fitted under shed', label: 'Installed/Fitted under shed' },
  { value: 'Installed/Fitted above shed', label: 'Installed/Fitted above shed' },
  { value: 'Dormant Stock', label: 'Dormant Stock' },
  { value: 'Office Inventory', label: 'Office Inventory' },
  { value: 'As Condemnation Stock', label: 'As Condemnation Stock' },
];
const PendingConsumablesLedger = ({ accessOfDepartments, accessedLedgers }) => {
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const code = localStorage.getItem('code');
  const token = localStorage.getItem('token');
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [originalData, setOriginalData] = useState([]);


  const typeOptions = [
    { value: "Asset", label: "Asset / Capital Nature" },
    { value: "Consumables", label: "Useable / Consumables" },
    { value: "Fixtures & Fittings", label: "Fixtures & Fittings" },
    { value: "Constructed Structure", label: "Constructed Structure" },
  ];

  const filteredData = React.useMemo(() => {
    if (!selectedTypes || selectedTypes.length === 0) {
      return originalData;
    }

    const selectedValues = selectedTypes.map(t => t.value);

    return originalData.filter(row =>
      selectedValues.includes(row.type)
    );
  }, [originalData, selectedTypes]);

  useEffect(() => {
    if (accessOfDepartments) {
      const deptArray = accessOfDepartments
        .split(',')
        .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
      setDepartments(deptArray);
    }
  }, [accessOfDepartments]);
  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/ledgerMastersMainTain', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });

      // Convert accessedLedgers (string like "45,54,58,89") into an array of numbers
      const accessedLedgerIds = accessedLedgers
        .split(',')
        .map((id) => parseInt(id.trim()));

      // Filter ledgers that are in accessedLedgers
      const filteredLedgers = response.data.filter((ledger) =>
        accessedLedgerIds.includes(ledger.id)
      );

      // Prepare options for dropdown
      const options = response.data.map((ledger) => ({
        value: ledger.printName,
        label: ledger.printName,
        ledgerId: ledger.id,
        group: ledger.ledgerGroup,
        address: ledger.address,
        gstin: ledger.gstin,
      }));

      setLedgerOptions(options);
    } catch (error) {
      console.error('Error fetching ledger master details:', error);
    }
  };
  useEffect(() => {
    fetchledgermasterdetails()
  }, [accessedLedgers]);
  const getReport = async () => {

    if (!selectedLedger) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'Please select Ledger',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'Please select a valid date range',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    setLoading(true);

    try {
      const [startDate, endDate] = dateRange;

      const res = await apiClient.get(SERVER_BASE + '/getPendingConsumablesLedger', {
        params: {
          ledgerId: selectedLedger.ledgerId,
          startDate: startDate,
          endDate: endDate,

        },
      });
      setOriginalData(res.data.report);

    } catch (error) {
      console.error('Error fetching report:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      Cell: ({ row }) => row.index + 1,
    },
    { Header: 'Item', accessor: 'printName' },
    // { Header: 'Opening Stock', accessor: 'openingQty' },
    // { Header: 'Addition', accessor: 'totalAdd' },
    // { Header: 'Deduction', accessor: 'totalLess' },
    { Header: 'Stock', accessor: 'closingQty' },
    { Header: 'UOM', accessor: 'uom' },
    // { Header: 'Type', accessor: 'type' },
  ], []);

  const {
    getTableProps, getTableBodyProps, headerGroups, page,
    prepareRow, setGlobalFilter, state, nextPage, previousPage,
    canNextPage, canPreviousPage, pageOptions, setPageSize
  } = useTable(
    { columns, data: filteredData, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const exportToExcel = async () => {
    if (!Array.isArray(filteredData)) {
      console.error("filteredData is not an array:", filteredData);
      alert("No data available to export.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Pending Consumables - Ledger');

    // Top merged label rows
    worksheet.mergeCells('A1:G1');
    worksheet.getCell('A1').value = `Ledger: ${selectedLedger?.value || 'All'}`;
    worksheet.getCell('A1').font = { bold: true };

    worksheet.mergeCells('A2:G2');
    const [startDate, endDate] = dateRange;
    worksheet.getCell('A2').value = `Date Range: ${moment(startDate).format('DD-MMM-YY') || 'N/A'} to ${moment(endDate).format('DD-MMM-YY') || 'N/A'}`;
    worksheet.getCell('A2').font = { bold: true };

    // Define column structure without auto header row
    worksheet.columns = [
      { key: 'printName', width: 30 },
      //   { key: 'openingStock', width: 20 },
      //   { key: 'totalAdd', width: 20 },
      //   { key: 'totalLess', width: 20 },
      { key: 'closingStock', width: 20 },
      { key: 'uom', width: 10 },
      //   { key: 'type', width: 30 },
    ];

    // Manually add header row at row 4
    const headerRow = worksheet.getRow(3);
    headerRow.values = [, 'Item', 'Stock', 'UOM']; // 1-based indexing
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Add data rows starting from row 5
    filteredData.forEach(row => {
      worksheet.addRow({
        printName: row.printName,
        // openingStock: row.openingQty ?? 0,
        // totalAdd: row.totalAdd ?? 0,
        // totalLess: row.totalLess ?? 0,
        closingStock: row.closingQty ?? 0,
        uom: row.uom || '',
        // type: row.type || '',
      });
    });

    // Apply border and alignment from header row onward
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 4) {
        row.eachCell(cell => {
          cell.border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        });
      }
    });

    // Freeze top 4 rows
    worksheet.views = [{ state: 'frozen', ySplit: 4 }];

    // Export to Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Pending Consumables - Ledger Report  ${moment().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div className="formcontainer">
      <h3>Pending Consumables - Ledger</h3>
      <div className="mb-4">
        <div className="row align-items-end mb-3">
          <div className="col-md-5">
            <label className="form-label">Ledger</label>
            <Select options={ledgerOptions} value={selectedLedger} onChange={setSelectedLedger} />
          </div>
          {/* <div className="col-md-4">
            <label className="form-label">Department</label>
            <Select
              isMulti
              options={departments}
              value={selectedDept}
              onChange={setSelectedDept}
            />

          </div> */}
          <div className="col-md-3">
            <label className="form-label">Date Range</label>
            <DateRangePickerComponent value={dateRange} onChange={setDateRange} />
          </div>


          <div className="col-md-2">
            <button
              className="btn btn-outline-success w-100"
              onClick={getReport}
              disabled={loading}
            >
              {loading ? 'Loading...' : 'Get Report'}
            </button>
          </div>
        </div>
      </div>


      <div className="row align-items-center mb-2">
        <div className="col-md-5">
          <input
            className="form-control"
            placeholder="Search..."
            onChange={e => setGlobalFilter(e.target.value)}
          />
        </div>
        {originalData.length > 0 && (
          <div className="col-md-3 text-end">
            <button className="btn btn-success w-100" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
        )}
      </div>

      <table
        style={{ fontSize: '15px', verticalAlign: 'baseline' }}
        className="table table-striped table-bordered"
        {...getTableProps()}
      >
        <thead className="thead-dark">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length == 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center text-muted py-3">
                No data found for the selected filter
              </td>
            </tr>
          ) : (
            page.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>

      </table>

      <div className="row mt-3 align-items-center">
        <div className="col-md-4 d-flex justify-content-start">
          <button className="btn btn-outline-secondary me-2" onClick={() => previousPage()} disabled={!canPreviousPage}>
            Previous
          </button>
        </div>
        <div className="col-md-4 d-flex flex-column align-items-center">
          <span>
            Page {state.pageIndex + 1} of {pageOptions.length}
          </span>
          <div className="d-flex align-items-center mt-1">
            <label className="me-2 mb-0">Rows per page:</label>
            <select
              className="form-select form-select-sm w-auto"
              value={state.pageSize}
              onChange={e => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map(size => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          <button className="btn btn-outline-secondary" onClick={() => nextPage()} disabled={!canNextPage}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default PendingConsumablesLedger;
